<template>
  <div>
    <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
    <default-table
      :items="usuarios"
      :fields="fields"
      :sort-by="componenteOrdenacao.campo"
      :sort-direction="componenteOrdenacao.sentido"
      :busy="flagsDeControle.carregandoDados.status"
      @sortChanged="ordenarLista"
      :tbody-tr-class="tabelaSemRegistros">
      <template #empty>
        <em>Nenhum registro encontrado.</em>
      </template>
      <template #cell(nome)="row">
        <span :class="destacarUsuarioInativo(row.item.ativo)">
          {{ row.item.nome }}
        </span>
      </template>
    </default-table>
    <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
  </div>
</template>

<script>
import Usuarios from './js/usuarios'
export default Usuarios
</script>
